import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import type { StyleProp, ViewStyle } from 'react-native';

import { useTheme } from '../context/ThemeContext';
import { spacing, fontSize } from '../utils/theme';

/**
 * PageFooter - the RinsePay trademark footer rendered at the end of every
 * page: generous whitespace, then a small centered gray line. Wired into
 * ContentContainer by default (footer prop) so most screens get it for
 * free; screens without ContentContainer (or whose ContentContainer wraps
 * the scroll instead of living inside it) render it explicitly at the end
 * of their scroll content.
 */
interface PageFooterProps {
  readonly style?: StyleProp<ViewStyle>;
}

export default function PageFooter({ style }: PageFooterProps) {
  const { colors } = useTheme();
  return (
    <View style={[styles.wrap, style]}>
      <Text style={[styles.text, { color: colors.textSecondary }]}>
        © 2026 RinsePay™ — Payments Made Simple
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { paddingTop: spacing.xxl, paddingBottom: spacing.lg, alignItems: 'center' },
  text: { fontSize: fontSize.xs, textAlign: 'center' },
});
